export enum AuthenticationTokenLocation {
  QUERY_STRING = 'QUERY_STRING',
  COOKIE = 'COOKIE',
  BOTH = 'BOTH',
}
